import React from 'react'

export function Booking(props) {
  return (
        // <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" color='black' viewBox="0 0 310 310" {...props}><path d="M288.32 49.87H183.19v210.26L288.32 155zM126.81 155V49.87H21.68v210.26z" fill="#000000"></path></svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">

            <rect x="20" y="10" width="60" height="80" fill="none" stroke="black" strokeWidth="3"/>
            
            <rect x="20" y="10" width="10" height="80" fill="none" stroke="black" strokeWidth="3"/>
            
            <path d="M30 10 L30 90" stroke="black" strokeWidth="2"/>
            <path d="M40 10 L40 90" stroke="black" strokeWidth="2"/>
            <path d="M50 10 L50 90" stroke="black" strokeWidth="2"/>
            <path d="M60 10 L60 90" stroke="black" strokeWidth="2"/>
            <path d="M70 10 L70 90" stroke="black" strokeWidth="2"/>
        </svg>
    )
}
export default Booking